import { Component, OnInit, EventEmitter, Input, Output } from '@angular/core';
import { FormGroup, FormBuilder, Validators, FormArray, FormControl } from '@angular/forms';
import * as _ from 'lodash';
import { AmToasterService } from '@angularminds/am-toaster';

@Component({
  selector: 'app-column-mapper',
  templateUrl: './column-mapper.component.html',
  styleUrls: ['./column-mapper.component.css'],
})
export class ColumnMapperComponent implements OnInit {
  @Input() model: any = [];
  @Input() parsedColumns: any[];
  @Input() isButtonDisabled: boolean = false;
  @Input() title: string = 'Column mapping';
  @Input() submitButtonText: string = 'Submit';
  @Input() cancelButtonText: string = 'Cancel';
  @Output() mappedData: EventEmitter<any[]> = new EventEmitter();
  @Output() onCancel: EventEmitter<boolean> = new EventEmitter();

  form: FormGroup;
  mapping: FormArray;
  columns: string[];
  processedMapping: any[];
  isTouched: boolean;

  constructor(private fb: FormBuilder, private amToasterService: AmToasterService) {}

  ngOnInit(): void {
    this.buildForm();
  }

  buildForm() {
    this.form = this.fb.group({
      mapping: new FormArray([]),
    });
    this.mapping = this.form.get('mapping') as FormArray;
    this.columns = Object.keys(this.parsedColumns[0]);
    this.buildMapping();
  }

  buildMapping() {
    this.model.forEach((element: any) => {
      this.mapping.push(
        new FormGroup({
          label: new FormControl(element.label),
          model: new FormControl(element.id),
          column: new FormControl(''),
          preview: new FormControl(''),
        }),
      );
    });
  }

  get f() {
    return this.mapping.controls;
  }

  async onSubmit() {
    if (this.form.invalid) {
      return;
    }
    if (!this.isTouched) {
      this.amToasterService.show('error', `Please select at least one column!`);
      return;
    }

    this.processedMapping = await this.processMapping(this.form.value.mapping);
    this.mappedData.emit(this.processedMapping);
  }

  async processMapping(mapping: any[]) {
    return _.map(this.parsedColumns, (data: any) => {
      let obj: any = {};
      mapping.forEach(async (m: any) => {
        obj = await this.assign(obj, m.model, data[m.column]);
      });
      return obj;
    });
  }

  onColumnSelect(event: any, index: number) {
    this.isTouched = true;
    this.f[index]['controls']['preview'].setValue(this.parsedColumns[0][event.target.value]);
  }

  cancel() {
    this.onCancel.emit(true);
  }

  async assign(obj: any, keyPath: any, value: any) {
    keyPath = keyPath.split('.');
    const lastKeyIndex = keyPath.length - 1;
    for (var i = 0; i < lastKeyIndex; ++i) {
      const key = keyPath[i];
      if (!(key in obj)) {
        obj[key] = {};
      }
      obj = obj[key];
    }
    obj[keyPath[lastKeyIndex]] = value;
    return obj;
  }
}
